/* tslint:disable */
/* eslint-disable */
/**
 * Coproperty API
 * MRI coproperties (the risk entity of the MRI branch) — creation, structural attributes, buildings, and attachment to the risk.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Eligible = all criteria met; ACompleter = a correctable piece of data is missing; NonEligible = a blocking criterion fails.
 * @export
 */
export const CopropertyEligibilityStatus = {
    Eligible: 'Eligible',
    ACompleter: 'ACompleter',
    NonEligible: 'NonEligible'
} as const;
export type CopropertyEligibilityStatus = typeof CopropertyEligibilityStatus[keyof typeof CopropertyEligibilityStatus];


export function instanceOfCopropertyEligibilityStatus(value: any): boolean {
    for (const key in CopropertyEligibilityStatus) {
        if (Object.prototype.hasOwnProperty.call(CopropertyEligibilityStatus, key)) {
            if (CopropertyEligibilityStatus[key as keyof typeof CopropertyEligibilityStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CopropertyEligibilityStatusFromJSON(json: any): CopropertyEligibilityStatus {
    return CopropertyEligibilityStatusFromJSONTyped(json, false);
}

export function CopropertyEligibilityStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): CopropertyEligibilityStatus {
    return json as CopropertyEligibilityStatus;
}

export function CopropertyEligibilityStatusToJSON(value?: CopropertyEligibilityStatus | null): any {
    return value as any;
}

export function CopropertyEligibilityStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): CopropertyEligibilityStatus {
    return value as CopropertyEligibilityStatus;
}

